import AdminSettingsDisplayHome from "@/components/ui/organisms/Admin/Settings/Display/AdminSettingsDisplayHome";
import AdminSettingsDisplaySelectInterface, { SelectInterfaceOption } from "@/components/ui/organisms/Admin/Settings/Display/AdminSettingsDisplaySelectInterface";
import { useSelectedLinkContext } from "@/contexts";
import { SAVE_DEVICE_SETTINGS } from "@/graphql/admin/settings/SettingsMutations";
import { GET_DEVICE_DISPLAY_SETTINGS, GET_STANDBY_DELAYS } from "@/graphql/admin/settings/SettingsQueries";
import { DisplaySettings, QueryGetDisplaySettingsResponse } from "@/types/settings.types";
import { FetchResult, useMutation, useQuery } from "@apollo/client";
import { useState } from "react";

const AdminSettingsDisplayPage = (): JSX.Element => {

  const [step, setStep] = useState<string>('displayHome');
  const { selectedLink } = useSelectedLinkContext();
  const { data, refetch } = useQuery<QueryGetDisplaySettingsResponse>(
    GET_DEVICE_DISPLAY_SETTINGS,
    {
      variables: {
        getDeviceSettingsInput: {
          channel: selectedLink?.channelKey,
        }
      },
    },
  );

  const [saveDisplaySettingsGQL] = useMutation<any>(SAVE_DEVICE_SETTINGS);
  const saveDisplayDeviceSettings = (settings: DisplaySettings): Promise<FetchResult<any>> => {
    return saveDisplaySettingsGQL({
      variables: {
        saveDeviceSettingsInput: {
          channel: selectedLink.channelKey,
          settings: settings,
        },
      },
    });
  }

  const updateDisplaySettings = (settings: DisplaySettings): void => {
    saveDisplayDeviceSettings(settings)
      .then(() => {
        void refetch();
      }).catch((error) => {
        console.log(error);
      });
  }

  const changeStep = (newStep: string): void => {
    setStep(newStep);
  }  

  const selectInterfaceOptions: SelectInterfaceOption[] = [
    { title: 'STANDARD', preview: '', value: 'INTERFACE_LEVEL_STANDARD' },
    { title: 'GUIDÉ', preview: '', value: 'INTERFACE_LEVEL_ACCESS' }
  ];

  const selectThemeOptions: SelectInterfaceOption[] = [
    { title: 'THEME_2022_ARDOIZ', preview: '', value: 'THEME_2022_ARDOIZ' },
    { title: 'THEME_MAIN_ARDOIZ', preview: '', value: 'THEME_MAIN_ARDOIZ' },
    { title: 'THEME_FEMININE_ARDOIZ', preview: '', value: 'THEME_FEMININE_ARDOIZ' },
    { title: 'THEME_MASCULINE_ARDOIZ', preview: '', value: 'THEME_MASCULINE_ARDOIZ' },
    { title: 'CONTRASTÉ', preview: '', value: 'THEME_CONTRASTED_ARDOIZ' },
    { title: 'THEME_ORIGINAL_ARDOIZ', preview: '', value: 'THEME_ORIGINAL_ARDOIZ' },
  ];

  return (
    <div className="flex flex-col gap-2w bg-neutral-100">
      { step === 'displayMode' &&
        <AdminSettingsDisplaySelectInterface
          pageTitle="Sélection du mode d'affichage"
          pageDescription="Vous allez maintenant pouvoir choisir le mode d’affichage de votre ardoiz. Pour débuter en toute sénénité, nous vous conseillons d’utiliser le mode Guidé qui vous offrir un accompagnement plus poussé lors de votre navigation. Pour en savoir plus, appuyez sur le bouton APERÇU."
          onChange={(value: string) => updateDisplaySettings({ interfaceMode: value })}
          value={data?.getDeviceSettings?.settings?.interfaceMode}
          options={selectInterfaceOptions}
          backToHomeAction={() => changeStep('displayHome')} 
        />
      }
      { step === 'displayTheme' &&
        <AdminSettingsDisplaySelectInterface
          pageTitle="Sélection du thème"
          pageDescription="Sélectionnez un thème parmi les propositions suivantes. Vous pouvez voir un aperçu de chaque thème en cliquant sur le bouton “APERÇU”."
          onChange={(value: string) => updateDisplaySettings({ theme: value })}
          value={data?.getDeviceSettings?.settings?.theme}
          options={selectThemeOptions}
          backToHomeAction={() => changeStep('displayHome')} 
        />
      }
      { step === 'displayHome' &&
        <AdminSettingsDisplayHome 
          interfaceOptions={selectInterfaceOptions}
          themeOptions={selectThemeOptions}
          settings={data?.getDeviceSettings?.settings}
          updateDisplaySettings={updateDisplaySettings}
          changeStep={changeStep} 
        />
      }
    </div>
  )
}

export default AdminSettingsDisplayPage;